import { alpha, type Theme } from '@mui/material/styles';

export const formatBillingName = (name: string) => {
  return name
    .replace(/llm_generation\s*\(\s*/gi, '')
    .replace(/\)$/g, '')
    .replace(/llm_generation/gi, 'Generation')
    .replace(/workspace_initialization/gi, 'Tender Go Fee')
    .replace(/draft_response_gen/gi, 'Draft Response')
    .replace(/Draft Response Gen/gi, 'Draft Response')
    .replace(/draftResponse/gi, 'Draft Response')
    .replace(/alignment_analysis/gi, 'Capability Analysis')
    .replace(/alignmentAnalysis/gi, 'Capability Analysis')
    .replace(/capabilityPitch/gi, 'Capability Pitch')
    .replace(/visualExport/gi, 'Visual Export')
    .replace(/reviewResponse/gi, 'Review Response')
    .replace(/adhocDocumentGenerator/gi, 'Ad Hoc Document')
    .replace(/tenderDetailsExtractor/gi, 'Tender Extraction')
    .replace(/tenderInquiry/gi, 'Tender Inquiry')
    .replace(/quickReview/gi, 'Quick Review')
    .replace(/caseStudy/gi, 'Case Study Processing')
    .replace(/contextHunterIndex/gi, 'Deep Indexing')
    .replace(/context_hunter/gi, 'Document Search')
    .replace(/contextHunter/gi, 'Document Search')
    .replace(/people_cv/gi, 'Team Member Search')
    .replace(/cvProcessor/gi, 'CV Processing')
    .replace(/strictFormProcessor/gi, 'Strict Form Processing')
    .replace(/section_chat_validate/gi, 'Section Chat Validation')
    .replace(/^chat$/gi, 'Section Chat')
    .replace(/section_chat/gi, 'Section Chat')
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\b\w/g, (l) => l.toUpperCase())
    .replace(/Ai Generation/gi, 'AI Generation')
    .trim();
};

export const getRowColor = (theme: Theme, actionType: string, contextTag?: string) => {
  const key = (contextTag || actionType).toLowerCase().replace(/\s+/g, '');
  const op = 0.2; // 20% opacity for better distinction without bleeding

  if (key.includes('draftresponse')) {
    return alpha('#f44336', op); // Red
  }
  if (key.includes('capabilityanalysis') || key.includes('alignmentanalysis')) {
    return alpha('#9c27b0', op); // Purple
  }
  if (key.includes('teammember') || key.includes('people_cv')) {
    return alpha('#00bcd4', op); // Cyan
  }
  if (key.includes('deepindexing') || key.includes('contexthunterindex')) {
    return alpha('#ff9800', op); // Orange
  }
  if (key.includes('documentsearch') || key.includes('contexthunter')) {
    return alpha('#4caf50', op); // Green
  }
  if (key.includes('cvprocessing') || key.includes('cvprocessor')) {
    return alpha('#795548', op); // Brown
  }
  if (key.includes('gofee') || key.includes('workspace_initialization')) {
    return alpha('#ffc107', op); // Amber
  }
  if (key.includes('quickreview')) {
    return alpha('#e91e63', op); // Pink
  }
  if (key.includes('reviewresponse')) {
    return alpha('#3f51b5', op); // Indigo
  }
  if (key.includes('adhoc')) {
    return alpha('#8bc34a', op); // Light Green
  }
  if (key.includes('extraction') || key.includes('extractor')) {
    return alpha('#009688', op); // Teal
  }
  if (key.includes('pitch')) {
    return alpha('#cddc39', op); // Lime
  }
  if (key.includes('visual')) {
    return alpha('#607d8b', op); // Blue Grey
  }
  if (key.includes('case')) {
    return alpha('#673ab7', op); // Deep Purple
  }
  if (key.includes('strictform')) {
    return alpha('#d32f2f', op); // Dark Red
  }
  if (key.includes('sectionchat')) {
    return alpha('#2196f3', op); // Blue
  }
  if (key.includes('generalchat')) {
    return alpha('#03a9f4', op); // Light Blue
  }
  if (key.includes('inquiry')) {
    return alpha('#8e24aa', op); // Deep Purple Variant
  }
  if (key.includes('generation')) {
    return alpha('#f06292', op); // Pink Variant
  }

  return alpha(theme.palette.text.secondary, op);
};
